import api from "./api";

export async function fetchProfitLoss(token: string, params: { from?: string; to?: string }) {
  const res = await api.get(`/reports/profit-loss`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return res.data;
}

export async function fetchTrialBalance(token: string, params: { from?: string; to?: string }) {
  const res = await api.get(`/reports/trial-balance`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return res.data;
}

export async function fetchBalanceSheet(token: string, params: { asOf?: string }) {
  const res = await api.get(`/reports/balance-sheet`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return res.data;
}

export async function listJournals(token: string) {
  const res = await api.get(`/journals`, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
}

export async function getTenantSettings(token: string, tenantId: string) {
  const res = await api.get(`/accounting/settings/${tenantId}`, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
}

export async function updateTenantSettings(token: string, tenantId: string, body: { cogsMethod: "WA" | "FIFO" }) {
  const res = await api.put(`/accounting/settings/${tenantId}`, body, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
}

export async function runOpeningLayersMigration(token: string, tenantId: string, dryRun = false) {
  const res = await api.post(`/accounting/migrations/opening-layers`, { tenantId, dryRun }, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as { tenantId: string; dryRun: boolean; count: number; items: Array<{ itemId: string; qty: number; unitCost: number; created: boolean }>; };
}

